import { styled, TableCell, TableContainer, TableRow } from "@mui/material";

/**
 * Fælles tabel-stil for admin. Før havde hver side sin egen kopi med et tungt orange bånd;
 * nu er hovedet lyst og roligt, så indholdet i tabellen fylder mest.
 */
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.MuiTableCell-head`]: {
    backgroundColor: "#f0f1f4",
    color: theme.palette.text.primary,
    fontWeight: 600,
    whiteSpace: "nowrap",
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:hover": { backgroundColor: theme.palette.action.hover },
  "&:last-child td, &:last-child th": { borderBottom: 0 },
}));

export const TableWrapper = styled(TableContainer)(({ theme }) => ({
  width: "100%",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 10,
  backgroundColor: theme.palette.background.paper,
  overflowX: "auto",
})) as typeof TableContainer;

/** Kolonnen med øje/blyant/papirkurv: knapperne skal stå på én linje */
export const actionCellSx = { whiteSpace: "nowrap" as const, width: 1 };
